import { shallowRef } from 'vue';
import { canonicalLocale } from './locale';
import type { I18nPersist } from './persist';

/**
 * The Active locale, module-level: a single-page app has one. `undefined` until `setupI18n`,
 * and every read then gives the Default locale of its file.
 */
export const activeLocale = shallowRef<string | undefined>();

let persist: I18nPersist | undefined;

export function configurePersist(adapter: I18nPersist | undefined): void {
    persist = adapter;
}

/** Makes `locale` the Active locale and saves it through the `persist` adapter given to `setupI18n`. */
export function setLocale(locale: string): void {
    const canonical = canonicalLocale(locale);
    activeLocale.value = canonical;
    persist?.save(canonical);
}

/** Back to the state before `setupI18n`. For specs. */
export function resetI18n(): void {
    activeLocale.value = undefined;
    persist = undefined;
}
